export default [
  '/admin/',
  '/district/',
  '/family-resources/',
  '/family-mind-yeti/',
]
